import React from 'react';
import {GlobalStyles} from '@mui/system';
import ClashDisplaySemibold from 'assets/fonts/ClashDisplay-Semibold.ttf'
import BarlowRegular from 'assets/fonts/Barlow-Regular.ttf';
import default_theme from 'assets/themes/themes';

const GlobalStylesComponent = () => {
    return (
        <GlobalStyles
            styles={(theme) => ({
                '@font-face': [
                    {
                        fontFamily: 'Clash Display Semibold',
                        src: `url(${ClashDisplaySemibold}) format('ttf')`,
                        fontWeight: 600,
                        fontStyle: 'normal',
                    },
                    {
                        fontFamily: 'Barlow',
                        src: `url(${BarlowRegular}) format('ttf')`,
                        fontWeight: 400,
                        fontStyle: 'normal',
                    },
                ],
                html: {
                    height: '100%',
                },
                 body: {
                  margin: 0,
                  padding: 0,
                  backgroundColor: default_theme.palette.primary.main,
                  fontFamily: '"Barlow", sans-serif',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  display: 'flex',
                  flexDirection: 'column',
                },
                '#root': {
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: '100vh',
                },

                h1: {
                    fontFamily: '"Clash Display Semibold", sans-serif',
                    color: default_theme.palette.other.addButtonBlue,
                },
                a: {
                    color: default_theme.palette.primary.green,
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline',
                    }
                },
                p: {
                    color: default_theme.palette.font.gray,
                    fontFamily: '"Barlow", sans-serif',
                },

            })}
        />
    );
};

export default GlobalStylesComponent;
